/** Shared product-facing labels for live tools, saved transcript projection and UI.
 * Function identifiers remain internal; custom playbook phase labels may include counts. */
export const AGENT_ACTION_LABELS: Readonly<Record<string,string>> = {
  "discover_meta_reporting": "Checking Meta AI reporting",
  "read_meta_report": "Reading a Meta report",
  "get_saved_briefs": "Reading saved briefs",
  "find_saved_brand_angles": "Finding saved brand angles",
  "revise_saved_brief_visual": "Updating the selected visual brief",
  "get_current_context": "Reading the selected context",
  "list_brands": "Loading your brands",
  "get_saved_brand_ads": "Reading stored public brand ads",
  "rescan_competitor_ads": "Rescanning saved competitor ads",
  "get_competitor_scan_status": "Reading saved competitor scan status",
  "get_brand_info": "Reading your brand and products",
  "update_identity": "Saving brand or product settings",
  "update_competitor": "Saving competitor settings",
  "scrape_and_analyze_brand": "Analyzing brand website",
  "create_brand": "Saving brand to platform",
  "discover_competitors": "Discovering competitors",
  "save_competitor": "Saving competitor profile",
  "list_competitors": "Loading competitors",
  "search_ad_library": "Analyzing competitor Facebook ads",
  "analyze_ad_creative_vision": "Analyzing ad creatives",
  "analyze_my_live_ads": "Analyze Ads",
  "search_heartbeat": "Searching brand memory",
  "get_ad_performance": "Loading ad performance",
  "generate_ad_copy": "Generating ad copy",
  "generate_ad_angles": "Generating ad angles",
  "get_campaign_data": "Loading campaign data",
  "generate_ad_image": "Generating ad image",
  "generate_campaign_creatives": "Generating campaign creatives",
  "check_generation_status": "Checking image generation status",
  "save_ad_angles": "Saving ad angles",
  "move_chat_to_folder": "Organizing chat",
  "evaluate_creative": "Evaluating ad quality",
  "get_performance_summary": "Reading performance",
  "get_ad_breakdown": "Ranking ads",
  "get_metric_trend": "Loading trend",
  "compare_periods": "Comparing periods",
  "run_campaign_v2": "Running Campaign Start",
  "run_campaign_targeted": "Running Targeted Campaign",
  "run_campaign_v3": "Choosing and adapting inspiration",
  "run_source_copy_angles": "Creating new copy and angles",
  "run_variations_v3": "Creating ad variations",
  "run_create_variants": "Creating aspect-ratio variants",
  "run_my_ads": "Adapting your existing ads",
  "run_competitor_ads": "Adapting competitor ads",
  "run_angles_to_campaign": "Creating your ads",
  "run_brand_onboarding": "Setting up your brand",
  "run_edit_fixes": "Applying your edits",
  "run_create_angle_set": "Planning your ads",
  "get_report_ad_creative": "Reading the referenced ad",
  "get_conversation_history": "Reading earlier messages",
  "get_job_status": "Checking progress",
  "cancel_job": "Stopping the requested work",
  "present_saved_brand_ads": "Showing your existing ads",
  "generate_video": "Creating your video",
  "edit_video_frame": "Editing the selected video frame",
  "local_read": "Reading a workspace file",
  "local_glob": "Finding workspace files",
  "local_grep": "Searching workspace files",
  "local_write": "Saving a workspace file",
  "local_edit": "Updating a workspace file",
  "local_bash": "Running a workspace command"
};
export function publicActionLabel(toolName:string='', savedLabel?:string):string {
  return AGENT_ACTION_LABELS[toolName] ?? (savedLabel && savedLabel !== toolName && savedLabel !== toolName.replaceAll('_',' ') ? savedLabel : 'Working on your request');
}
